export enum CalendlyEvents {
  PROFILE_PAGE_VIEWED = 'calendly.profile_page_viewed',
  EVENT_TYPE_VIEWED = 'calendly.event_type_viewed',
  SELECTS_DATE = 'calendly.date_and_time_selected',
  SCHEDULES_EVENT = 'calendly.event_scheduled',
}

export interface CalendlyEventType {
  event: string
  payload: object
}
